import { APP_NAME } from '../lib/appConfig';

// Internationalization (i18n)
// Supported languages: French (fr), English (en), Wolof (wo)

export const translations = {
  fr: {
    // Navigation
    nav: {
      dashboard: 'Tableau de bord',
      tontines: 'Mes Tontines',
      contributions: 'Cotisations',
      referrals: 'Parrainage',
      chat: 'Coach IA',
      admin: 'Admin',
      profile: 'Mon profil',
      settings: 'Paramètres',
      logout: 'Déconnexion',
    },
    
    // Auth
    auth: {
      login: 'Connexion',
      register: 'Inscription',
      email: 'Email',
      password: 'Mot de passe',
      fullName: 'Nom complet',
      phone: 'Téléphone',
      country: 'Pays',
      loginButton: 'Se connecter',
      registerButton: "S'inscrire",
      forgotPassword: 'Mot de passe oublié ?',
      noAccount: "Vous n'avez pas de compte ?",
      hasAccount: 'Vous avez déjà un compte ?',
      referralCode: 'Code de parrainage (optionnel)',
    },
    
    // Dashboard
    dashboard: {
      welcome: 'Bienvenue',
      totalTontines: 'Total Tontines',
      totalContributed: 'Total Cotisé',
      nextPayout: 'Prochain Versement',
      pendingContributions: 'Cotisations en attente',
      recentActivity: 'Activité récente',
      quickActions: 'Actions rapides',
      createTontine: 'Créer une tontine',
      joinTontine: 'Rejoindre une tontine',
    },
    
    // Tontines
    tontine: {
      create: 'Créer une tontine',
      join: 'Rejoindre',
      name: 'Nom de la tontine',
      description: 'Description',
      type: 'Type',
      types: {
        rosca: 'ROSCA (Rotative)',
        asca: 'ASCA (Accumulative)',
        flex_asca: 'ASCA flexible (épargne libre)',
        hybrid: 'Hybride',
      },
      contribution: 'Cotisation',
      frequency: 'Fréquence',
      frequencies: {
        weekly: 'Hebdomadaire',
        biweekly: 'Bi-mensuelle',
        monthly: 'Mensuelle',
      },
      currency: 'Devise',
      maxMembers: 'Membres max',
      currentMembers: 'Membres actuels',
      startDate: 'Date de début',
      rules: 'Règlement',
      status: 'Statut',
      statuses: {
        active: 'Active',
        pending: 'En attente',
        completed: 'Terminée',
        paused: 'En pause',
      },
      members: 'Membres',
      position: 'Position',
      admin: 'Administrateur',
      member: 'Membre',
    },
    
    // Settings
    settings: {
      title: 'Paramètres',
      paymentMode: 'Mode de paiement',
      paymentModes: {
        adminOnly: 'Suivi seul',
        adminOnlyDesc: "L'admin enregistre toutes les cotisations",
        direct: 'Paiement direct',
        directDesc: 'Les membres paient eux-mêmes via l\'app',
      },
      visibilityMode: 'Mode de visibilité',
      visibilityModes: {
        restricted: 'Restriction',
        restrictedDesc: 'Les membres voient uniquement leurs propres informations',
        transparent: 'Non restriction',
        transparentDesc: 'Transparence totale - tous voient tout',
      },
      automation: 'Automatisation',
      reminders: 'Rappels automatiques',
      reminderDays: 'Jours avant échéance',
      autoRotation: 'Rotation automatique',
      penalties: 'Pénalités',
      penaltyEnabled: 'Activer les pénalités',
      penaltyRate: 'Taux de pénalité',
      gracePeriod: 'Délai de grâce (jours)',
      save: 'Enregistrer',
      saved: 'Paramètres enregistrés',
    },
    
    // Contributions
    contributions: {
      title: 'Cotisations',
      pay: 'Payer',
      record: 'Enregistrer paiement',
      amount: 'Montant',
      date: 'Date',
      method: 'Méthode',
      status: 'Statut',
      statuses: {
        completed: 'Complété',
        pending: 'En attente',
        failed: 'Échoué',
      },
      paymentMethods: {
        wave: 'Wave',
        orangeMoney: 'Orange Money',
        stripe: 'Carte bancaire',
        cash: 'Espèces',
      },
      selectMember: 'Sélectionner un membre',
      recordFor: 'Enregistrer pour',
    },
    
    // Notifications
    notifications: {
      title: 'Notifications',
      subtitle: 'Suivez vos alertes et actions récentes',
      markAllRead: 'Tout lire',
      markAllSuccess: 'Notifications marquées comme lues',
      noNotifications: 'Aucune notification',
      showUnread: 'Afficher non lues',
      showAll: 'Afficher toutes',
      viewAll: 'Voir toutes',
      loadError: 'Erreur lors du chargement des notifications',
      actionError: 'Erreur lors de la mise à jour',
      now: "À l'instant",
      minutesAgo: 'Il y a {count} min',
      hoursAgo: 'Il y a {count} h',
      daysAgo: 'Il y a {count} j',
      types: {
        contributionRecorded: 'Cotisation enregistrée',
        contributionReminder: 'Rappel de cotisation',
        payoutReceived: 'Versement reçu',
        memberJoined: 'Nouveau membre',
        rotationExecuted: 'Rotation effectuée',
        tontineInvite: 'Invitation à une tontine',
        referralBonus: 'Bonus de parrainage',
      },
    },
    
    // Invitations
    invite: {
      title: 'Inviter des membres',
      link: 'Lien d\'invitation',
      qrCode: 'QR Code',
      code: 'Code d\'invitation',
      email: 'Par email',
      addManual: 'Ajouter manuellement',
      copyLink: 'Copier le lien',
      copied: 'Lien copié !',
      sendInvite: 'Envoyer l\'invitation',
      expires: 'Expire dans',
      usesLabel: 'Utilisations',
      auditTitle: 'Historique des invitations',
      reasonLabel: 'Raison',
      auditEvents: {
        invite_created: 'Invitation créée',
        invite_redeemed: 'Invitation utilisée',
        invite_expired: 'Invitation expirée',
        invite_revoked: 'Invitation révoquée',
      },
      days: 'jours',
    },
    
    // Common
    common: {
      loading: 'Chargement...',
      error: 'Erreur',
      success: 'Succès',
      cancel: 'Annuler',
      confirm: 'Confirmer',
      save: 'Enregistrer',
      delete: 'Supprimer',
      edit: 'Modifier',
      view: 'Voir',
      back: 'Retour',
      page: 'Page',
      pageSize: 'Taille',
      next: 'Suivant',
      previous: 'Précédent',
      search: 'Rechercher',
      filter: 'Filtrer',
      export: 'Exporter',
      import: 'Importer',
      download: 'Télécharger',
      upload: 'Téléverser',
      yes: 'Oui',
      no: 'Non',
      all: 'Tous',
      none: 'Aucun',
    },

    validation: {
      required: 'Ce champ est obligatoire.',
      email: 'Veuillez saisir une adresse email valide.',
      invalid: 'La valeur saisie est invalide.',
      minLength: 'Veuillez saisir au moins {min} caracteres.',
      minValue: 'La valeur doit etre superieure ou egale a {min}.',
      maxValue: 'La valeur doit etre inferieure ou egale a {max}.',
      invalidFormat: 'Le format saisi est invalide.',
    },
    
    // Countries
    countries: {
      SN: 'Sénégal',
      CA: 'Canada',
      FR: 'France',
      CI: "Côte d'Ivoire",
      ML: 'Mali',
      BF: 'Burkina Faso',
      CM: 'Cameroun',
      US: 'États-Unis',
    },
    
    // PWA
    pwa: {
      install: 'Installer',
      installNow: 'Installer maintenant',
      bannerTitle: `Installer ${APP_NAME}`,
      bannerDescription: 'Accédez rapidement à vos tontines depuis votre écran d\'accueil.',
      iosInstructions: 'Appuyez sur Partager puis "Sur l\'écran d\'accueil"',
    },

    authPage: {
      backHome: "Retour à l'accueil",
      loginDescription: 'Connectez-vous à votre compte',
      registerDescription: 'Créez votre compte',
      loginError: 'Erreur de connexion',
      registerError: "Erreur lors de l'inscription",
      emailPlaceholder: 'votre@email.com',
      namePlaceholder: 'Amadou Diallo',
      phoneOptional: 'Téléphone (optionnel)',
      phonePlaceholder: '+221 77 123 45 67',
      createAccountButton: 'Créer mon compte',
    },

    referralsPage: {
      title: 'Parrainage',
      subtitle: 'Invitez vos proches et gagnez des récompenses',
      yourCode: 'Votre code de parrainage',
      shareAction: 'Partager',
      codeCopied: 'Code copié !',
      linkCopied: 'Lien de parrainage copié !',
      shareText: 'Rejoins {appName} et gère tes tontines en toute sécurité ! Utilise mon code de parrainage : {referralCode}',
      shareTitle: '{appName} - Parrainage',
      stats: {
        referrals: 'Filleuls',
        active: 'Actifs',
        bonusEarned: 'Bonus gagné',
        points: 'Points',
      },
      benefitsTitle: 'Vos avantages',
      myReferrals: 'Mes filleuls ({count})',
      noReferrals: 'Aucun filleul pour le moment',
      noReferralsHelp: 'Partagez votre code de parrainage pour inviter vos amis et gagner des bonus !',
      status: {
        active: 'Actif',
        pending: 'En attente',
      },
    },

    landing: {
      navLogin: 'Connexion',
      navStart: 'Commencer',
      heroTagline: "L'épargne communautaire réinventée",
      heroTitlePrefix: 'Gérez vos tontines en toute',
      heroTitleHighlight: 'confiance',
      heroDescription: 'La plateforme professionnelle pour créer, gérer et sécuriser vos tontines. Du Sénégal au Canada, modernisez votre épargne collective.',
      heroPrimaryCta: 'Créer ma tontine',
      heroSecondaryCta: 'En savoir plus',
      freeToStart: 'Gratuit pour démarrer',
      secureData: 'Données sécurisées',
      imageAlt: 'Application de tontine',
      savedFcfa: 'FCFA économisés',
      typesEyebrow: 'Types de tontines',
      typesTitle: 'Choisissez votre formule',
      featuresEyebrow: 'Fonctionnalités',
      featuresTitle: 'Tout ce dont vous avez besoin',
      ctaTitle: 'Prêt à moderniser votre tontine ?',
      ctaDescription: 'Rejoignez des milliers d\'utilisateurs qui font confiance à {appName} pour gérer leur épargne collective.',
      ctaButton: 'Commencer gratuitement',
      footerCopyright: '© {year} {appName}. Tous droits réservés. TRA-TECH. Email: contact@tra-tech.com/ sadiboutra@gmail.com. Siège social: Ouest Foire, Dakar, Sénégal.',
      footerPrivacy: 'Confidentialité',
      footerTerms: 'Conditions',
      features: {
        group: {
          title: 'Gestion de groupe simplifiée',
          description: 'Invitez vos membres, définissez les règles et suivez les contributions en temps réel.',
        },
        security: {
          title: 'Sécurité maximale',
          description: 'Chiffrement de bout en bout, audit trail complet et détection de fraude automatique.',
        },
        payments: {
          title: 'Paiements flexibles',
          description: 'Wave, Orange Money, Stripe - tous vos moyens de paiement préférés.',
        },
        coach: {
          title: 'Coach IA intégré',
          description: 'Un assistant intelligent pour vous guider dans la création et gestion de vos tontines.',
        },
        currencies: {
          title: 'Multi-devises',
          description: 'XOF pour le Sénégal, CAD pour le Canada. Gérez vos tontines où que vous soyez.',
        },
        dashboard: {
          title: 'Tableaux de bord',
          description: 'Visualisez vos économies, suivez les rotations et anticipez vos versements.',
        },
      },
      types: {
        rosca: {
          title: 'Rotation traditionnelle',
          description: 'Chaque membre reçoit le pot à tour de rôle. Simple et équitable.',
        },
        asca: {
          title: 'Épargne collective',
          description: 'Constituez un fonds commun avec possibilité de prêts entre membres.',
        },
        hybrid: {
          title: 'Personnalisé',
          description: 'Combinez rotation et épargne selon les besoins de votre groupe.',
        },
      },
    },

    dashboardPage: {
      greetings: {
        morning: 'Bonjour',
        afternoon: 'Bon après-midi',
        evening: 'Bonsoir',
      },
      overviewSubtitle: 'Voici un aperçu de vos tontines',
      coachButton: 'Coach IA',
      newTontine: 'Nouvelle tontine',
      stats: {
        myTontines: 'Mes tontines',
        activeCount: '{count} actives',
        totalContributed: 'Total cotisé',
        totalReceived: 'Total reçu',
        pending: 'En attente',
        contributionsSuffix: 'cotisations',
      },
      myTontinesTitle: 'Mes tontines',
      viewAll: 'Voir tout',
      empty: {
        title: 'Aucune tontine',
        description: 'Créez votre première tontine ou rejoignez un groupe existant pour commencer.',
        createButton: 'Créer une tontine',
      },
      membersCount: '{current}/{max} membres',
      status: {
        active: 'Active',
      },
      contributionMonthly: '{amount} / mois',
      roundLabel: 'Tour {round}',
      quickActionsTitle: 'Actions rapides',
      quick: {
        createTitle: 'Créer une tontine',
        createDesc: 'Démarrer un nouveau groupe',
        contributeTitle: 'Cotiser',
        contributeDesc: 'Effectuer un versement',
        chatTitle: 'Coach IA',
        chatDesc: 'Poser une question',
      },
      nextContributionTitle: 'Prochaine cotisation',
      nextContributionDue: 'À payer ce mois',
      catchup: {
        title: 'Mes plans de rattrapage',
        installments: '{count} versement(s)',
        acceptButton: 'Accepter le plan',
        acceptedToast: 'Plan de rattrapage accepté',
        acceptError: 'Impossible d\'accepter le plan',
        status: {
          proposed: 'Proposé',
          accepted: 'Accepté',
          in_progress: 'En cours',
          failed: 'Échoué',
        },
      },
    },

    tontinesPage: {
      title: 'Mes Tontines',
      subtitle: 'Gérez et suivez vos groupes d\'épargne',
      newTontine: 'Nouvelle tontine',
      searchPlaceholder: 'Rechercher une tontine...',
      roundLabel: 'Tour {round}',
      viewDetails: 'Voir détails',
      empty: {
        noResults: 'Aucun résultat',
        noTontine: 'Aucune tontine',
        tryOtherSearch: 'Essayez un autre terme de recherche',
        createFirst: 'Créez votre première tontine pour démarrer l’épargne en groupe',
      },
      form: {
        namePlaceholder: 'Ex: Tontine Famille Diallo',
        descriptionPlaceholder: 'Objectif du groupe et règles...',
        contributionAmount: 'Montant cotisation',
        createButton: 'Créer une tontine',
      },
    },

    joinPage: {
      invalidOrExpired: 'Invitation invalide ou expirée',
      welcomeToast: 'Bienvenue dans {tontineName} !',
      joinError: 'Erreur lors de l\'adhésion',
      invalidTitle: 'Invitation invalide',
      backHome: 'Retour à l\'accueil',
      title: 'Rejoindre la tontine',
      fullTontine: 'Cette tontine est complète',
      joinButton: 'Rejoindre la tontine',
      loginToJoin: 'Se connecter pour rejoindre',
      needAccount: 'Vous devez avoir un compte pour rejoindre',
    },

    chatPage: {
      title: 'Coach Tontine',
      poweredByAi: 'Propulsé par IA',
      thinking: 'Réflexion en cours...',
      suggestionsTitle: 'Suggestions',
      inputPlaceholder: 'Posez votre question...',
      errorMessage: 'Désolé, une erreur s\'est produite. Veuillez réessayer.',
      welcomeMessage: 'Bonjour {firstName} ! Je suis Coach Tontine, votre assistant intelligent. 🎯\n\nJe peux vous aider à :\n• Comprendre les différents types de tontines\n• Créer et configurer votre groupe\n• Répondre à vos questions sur l\'épargne collective\n\nComment puis-je vous aider aujourd\'hui ?',
      suggestions: {
        rosca: 'Qu\'est-ce qu\'une tontine ROSCA ?',
        amount: 'Comment choisir le bon montant de cotisation ?',
        rules: 'Quelles sont les règles d\'un bon groupe ?',
      },
    },

    profilePage: {
      title: 'Mon profil',
      subtitle: 'Gérez vos informations personnelles',
      accountInfo: 'Informations du compte',
      accountInfoDesc: 'Mettez à jour vos données de profil',
      photoTitle: 'Photo de profil',
      photoHint: 'Importez une image carrée nette jusqu\'à 2 Mo.',
      photoAlt: 'Photo de profil',
      uploadPhoto: 'Changer la photo',
      removePhoto: 'Supprimer',
      invalidPhotoType: 'Veuillez sélectionner une image valide.',
      photoTooLarge: 'La photo ne doit pas dépasser 2 Mo.',
      photoReadError: 'Impossible de lire cette image.',
      saved: 'Profil mis à jour',
      saveError: 'Erreur lors de la mise à jour du profil',
    },

    settingsPage: {
      subtitle: 'Personnalisez votre expérience',
      profileTitle: 'Profil',
      profileDesc: 'Consultez vos informations publiques et votre photo.',
      editProfile: 'Modifier le profil',
      languageTitle: 'Langue',
      languageDesc: 'Choisissez la langue de l\'application',
      languageLabel: 'Langue d\'affichage',
      notificationsTitle: 'Notifications',
      notificationsDesc: 'Gérez les notifications push et alertes',
      preferencesTitle: 'Préférences',
      preferencesDesc: 'Ces préférences sont synchronisées automatiquement avec votre compte.',
      darkModeTitle: 'Mode sombre',
      darkModeDesc: 'Applique instantanément le thème sombre sur votre espace.',
      emailAlertsTitle: 'Alertes email',
      emailAlertsDesc: 'Continuez à recevoir les rappels et mises à jour par email.',
      newsletterTitle: 'Actualités produit',
      newsletterDesc: 'Recevez des nouveautés produit et conseils d\'usage.',
      privacyTitle: 'Confidentialité',
      privacyDesc: 'Choisissez comment votre profil est visible dans l\'application.',
      visibilityLabel: 'Visibilité du profil',
      saveError: 'Erreur lors de la sauvegarde des préférences',
      visibilityOptions: {
        restricted: 'Restreint',
        restrictedDesc: 'Seuls les éléments essentiels de votre profil sont visibles.',
        transparent: 'Transparent',
        transparentDesc: 'Votre profil complet est plus visible pour les autres membres.',
      },
    },

    pushManager: {
      title: 'Notifications push',
      description: 'Recevez des alertes même quand l\'application est fermée',
      notSupportedMessage: 'Les notifications push ne sont pas supportées par ce navigateur. Utilisez Chrome ou Firefox pour activer cette fonctionnalité.',
      enableTitle: 'Activer les notifications',
      enableDescription: 'Rappels de cotisation, confirmations de paiement, alertes',
      enabledMessage: 'Notifications activées',
      notificationTypesTitle: 'Types de notifications :',
      sendTest: 'Envoyer une notification de test',
      permissionDeniedTitle: 'Permission refusée',
      permissionDeniedDescription: 'Vous avez bloqué les notifications. Modifiez les paramètres de votre navigateur pour les réactiver.',
      compact: {
        notSupported: 'Non supporté par ce navigateur',
        enabled: 'Activées',
        disabled: 'Désactivées',
      },
      notificationTypes: {
        reminders: '📅 Rappels de cotisation (J-3, J-1, Jour J)',
        paymentConfirmation: '✅ Confirmation de paiement reçu',
        contributionRecorded: '🧾 Cotisation enregistrée par un admin',
        newMember: '👋 Nouveau membre dans votre tontine',
        rotation: '🔄 Rotation effectuée',
        referralBonus: '🎁 Bonus de parrainage et progression filleul',
        tontineInvite: '📩 Invitations tontine et statuts',
        catchupPlan: '📌 Plans de rattrapage à valider',
        importantAlerts: '⚠️ Alertes importantes',
      },
      toast: {
        permissionDenied: 'Permission de notification refusée',
        enabled: 'Notifications activées !',
        enableError: 'Erreur lors de l\'activation des notifications',
        disabled: 'Notifications désactivées',
        disableError: 'Erreur lors de la désactivation',
        testSent: 'Notification de test envoyée !',
        testError: 'Erreur lors du test',
      },
    },

    risk: {
      levels: {
        excellent: 'Excellent',
        good: 'Bon',
        moderate: 'Modéré',
        high: 'Risque élevé',
        critical: 'Critique',
      },
      badgeTitle: 'Score de risque: {score}/100',
      loadError: 'Erreur lors du chargement',
      memberDialogTitle: 'Score de Risque - {memberName}',
      memberDialogDescription: 'Analyse IA du profil de fiabilité',
      factorsTitle: 'Facteurs d\'évaluation',
      factors: {
        payment_regularity: 'Régularité des paiements',
        timeliness: 'Ponctualité',
        attendance: 'Présence',
        engagement: 'Engagement',
        history: 'Historique',
        contribution_consistency: 'Constance des cotisations',
      },
      aiAnalysisTitle: 'Analyse IA',
      recommendationsTitle: 'Recommandations',
      summaryTitle: 'Analyse des Risques',
      averageScore: 'Score moyen',
      distribution: 'Distribution',
      distributionItemTitle: '{level}: {count} membre(s)',
      highRiskMembers: '{count} membre(s) à risque',
      topMembers: 'Meilleurs membres',
      topMembersThresholdHint: 'Seuil top members = {minScore}',
      topMembersEmpty: 'Aucun membre éligible (score ≥ {minScore})',
    },

    adminDashboard: {
      title: 'Tableau de bord Administrateur',
      subtitle: 'Vue consolidée de toutes vos tontines',
      actions: {
        refresh: 'Actualiser',
        exportSuccess: 'Export CSV généré avec succès',
        exportError: 'Erreur lors de l\'export CSV',
        loadError: 'Impossible de charger le tableau admin',
      },
      stats: {
        managedTontines: 'Tontines Gérées',
        managedTontinesSubtitle: 'Actives et en cours',
        totalCollected: 'Total Collecté',
        thisMonth: 'Ce mois',
        pendingContributions: 'Cotisations en attente',
        pendingMembers: '{count} membres',
        riskAlerts: 'Alertes Risque',
        membersToWatch: 'Membres à surveiller',
      },
      charts: {
        contributionTrend: 'Évolution des Cotisations',
        last30Days: '30 derniers jours',
        amount: 'Montant',
        participationByTontine: 'Taux de Participation par Tontine',
        participation: 'Participation',
      },
      tontineFallbackName: 'Tontine',
      memberDistribution: {
        title: 'Répartition des Membres',
        active: 'Actifs',
        pending: 'En attente',
        inactive: 'Inactifs',
      },
      risk: {
        title: 'Alertes de Risque',
        subtitle: 'Membres nécessitant attention',
        scoreLabel: 'Score',
        mock: {
          consecutiveLate: '3 retards consécutifs',
          partialPayment: 'Paiement partiel',
          irregularity: 'Irrégularité',
        },
      },
      quickView: {
        title: 'Mes Tontines',
        subtitle: 'Vue rapide de toutes vos tontines',
        collected: 'Collecté',
      },
      health: {
        title: 'Santé de la tontine',
        subtitle: 'Score global, tendances et actions prioritaires',
        globalScore: 'Score global',
        atRiskCount: '{count} membre(s) à risque',
        trend30Days: 'Tendance sur 30 jours',
        scoreAxis: 'Score',
        recommendedActions: 'Actions recommandées',
        targetTontine: 'Tontine ciblée',
        selectTontine: 'Sélectionner une tontine',
        ctaRemind: 'Relancer',
        ctaCatchup: 'Plan de rattrapage',
        ctaGroupMessage: 'Message groupé',
        catchupStatusTitle: 'Suivi des plans de rattrapage',
        catchupProposed: 'Proposé',
        catchupAccepted: 'Accepté',
        catchupInProgress: 'En cours',
        catchupFailed: 'Échoué',
        topAtRisk: 'Membres à risque',
        noRiskMembers: 'Aucun membre à risque pour le moment',
        noTontine: 'Aucune tontine trouvée pour cette action',
        actionError: 'Erreur lors de l’action admin',
        groupMessageTemplate: 'Merci de régulariser votre cotisation cette semaine.',
      },
      access: {
        title: 'Gestion des accès admin',
        subtitle: 'Attribuez des rôles délégués avec des permissions limitées',
        targetTontine: 'Tontine ciblée',
        selectTontine: 'Sélectionner une tontine',
        member: 'Membre',
        selectMember: 'Sélectionner un membre',
        ownerExcludedHint: 'Le propriétaire ne peut pas recevoir un rôle délégué inférieur.',
        noEligibleMembers: 'Aucun membre éligible pour l’attribution',
        role: 'Rôle',
        expiresAt: 'Expiration (optionnel)',
        assign: 'Attribuer l’accès',
        currentAccess: 'Accès actifs',
        empty: 'Aucun accès délégué pour cette tontine',
        revoke: 'Révoquer',
        expiresLabel: 'Expire le',
        loadError: 'Impossible de charger les accès admin',
        formMissing: 'Veuillez choisir un membre et un rôle',
        createSuccess: 'Accès admin attribué avec succès',
        createError: 'Erreur lors de l’attribution de l’accès admin',
        updateSuccess: 'Rôle admin mis à jour',
        updateError: 'Erreur lors de la mise à jour du rôle',
        revokeSuccess: 'Accès admin révoqué',
        revokeError: 'Erreur lors de la révocation de l’accès',
        legendTitle: 'Légende des rôles',
        legendManager: 'Gestion complète (membres, invitations, paramètres)',
        legendCollector: 'Suivi des cotisations et relances',
        legendViewer: 'Consultation uniquement',
        roles: {
          manager: 'Manager',
          collector: 'Collecteur',
          viewer: 'Observateur',
        },
      },
    },

    tontineDetail: {
      notFound: 'Tontine non trouvée',
      backToTontines: 'Retour aux tontines',
      restrictedInfo: 'Mode restriction actif — vous voyez des infos limitées.',
      accessSummary: {
        title: 'Accès effectif',
        roleOwner: 'Rôle: Propriétaire',
        roleManager: 'Rôle: Manager',
        roleCollector: 'Rôle: Collecteur',
        roleViewer: 'Rôle: Observateur',
        roleMember: 'Rôle: Membre',
        capabilities: {
          manageMembers: 'Gérer membres',
          manageInvites: 'Gérer invitations',
          recordContributions: 'Enregistrer cotisations',
          updateSettings: 'Paramètres',
          executeRotation: 'Exécuter rotation',
          viewSensitiveData: 'Données sensibles',
        },
      },
      followOnlyMessage: 'Mode suivi seul - contactez l\'admin',
      rulesTitle: 'Règlement intérieur',
      noRules: 'Aucun règlement défini',
      infoTitle: 'Informations',
      createdOn: 'Créée le',
      currencyXof: 'Franc CFA (XOF)',
      currencyCad: 'Dollar canadien (CAD)',
      nextPayout: 'Prochain versement',
      membersTitle: 'Membres ({count})',
      positionLabel: 'Position #{position}',
      masked: 'Masqué',
      paid: 'Versé',
      viewRiskScore: 'Voir score de risque',
      contributionHistory: 'Historique des cotisations',
      restrictedContributionsInfo: 'Mode restriction — seules vos cotisations sont visibles.',
      noContributions: 'Aucune cotisation enregistrée',
      roundLabel: 'Tour {round}',
      tabs: {
        contributions: 'Cotisations',
      },
      stats: {
        contribution: 'Cotisation',
        totalCollected: 'Total collecté',
        currentRound: 'Tour actuel',
      },
      actions: {
        invite: 'Inviter',
        add: 'Ajouter',
        reminders: 'Rappels',
        smartReminders: 'Rappels intelligents',
        rotation: 'Rotation',
      },
      distribution: {
        title: 'Résumé de distribution',
        totalPot: 'Pot distribué: {amount}',
        newRound: 'Nouveau tour: {round}',
        closeAria: 'Fermer le résumé de distribution',
        memberFallback: 'Membre',
      },
      dialogs: {
        import: {
          title: 'Importer des membres',
          description: 'Ajoutez plusieurs membres via un fichier CSV',
        },
        invite: {
          title: 'Inviter des membres',
          description: 'Partagez le lien ou le QR code pour inviter des membres',
        },
        addMember: {
          title: 'Ajouter un membre',
          description: 'Ajoutez manuellement un membre à la tontine',
        },
        settings: {
          title: 'Paramètres automatisation',
          description: 'Configurez les rappels et rotations automatiques',
        },
      },
      paymentDialog: {
        recordContribution: 'Enregistrer une cotisation',
        chooseMethod: 'Choisir le mode de paiement',
        recordMemberContribution: 'Enregistrez la cotisation d\'un membre',
        selectPreferredMethod: 'Sélectionnez votre méthode de paiement préférée',
      },
      payment: {
        stripeCadOnly: 'Stripe disponible uniquement pour CAD',
        waveXofOnly: 'Wave disponible uniquement pour XOF',
        error: 'Erreur de paiement',
        you: 'vous',
        recordedFor: 'Cotisation enregistrée pour {memberName}',
        recordError: 'Erreur lors de l\'enregistrement',
        waveInstructions: 'Instructions Wave',
        reference: 'Référence',
        amountToRecord: 'Montant à enregistrer',
        mobileMoney: 'Mobile Money',
        cardBrands: 'Visa, Mastercard',
        recordCash: 'Enregistrer (espèces)',
        manualContribution: 'Cotisation manuelle',
        manualPayment: 'Paiement manuel',
      },
      import: {
        mode: 'Mode d\'import',
        modeBasic: 'Basique (nom, email, téléphone)',
        modeFull: 'Complet (+ position, montant initial)',
        downloadTemplate: 'Télécharger le template',
        csvFile: 'Fichier CSV',
        resultSummary: '{imported} importés, {skipped} ignorés',
        submit: 'Importer les membres',
        downloadError: 'Erreur lors du téléchargement',
        selectCsvError: 'Veuillez sélectionner un fichier CSV',
        importError: 'Erreur d\'import',
      },
      invite: {
        enterOneEmail: 'Entrez au moins un email',
        sentCount: 'Invitations envoyées à {count} personnes',
        emailPlaceholder: 'email1@example.com, email2@example.com',
        sendInvites: 'Envoyer les invitations',
      },
      addMember: {
        addedSuccess: 'Membre ajouté avec succès',
        addError: 'Erreur lors de l\'ajout',
        rotationPosition: 'Position dans la rotation',
        positionHelp: 'Laissez vide pour la prochaine position disponible',
        sendInvite: 'Envoyer une invitation',
        sendInviteHelp: 'Un email sera envoyé au nouveau membre',
      },
      settings: {
        remindersHelp: 'Envoyés automatiquement avant la date d\'échéance',
        reminderDay: 'J-{day}',
        smartReminders: 'Rappels intelligents',
        smartRemindersHelp: 'Priorise les membres à risque avec canal push/SMS puis fallback email',
        smartUrgentDays: 'Jours urgents (membres à risque)',
        autoRotationHelp: 'Exécuter le tirage à la date prévue',
        latePenalties: 'Pénalités de retard',
        latePenaltiesHelp: 'Appliquer des frais en cas de retard',
        penaltyRatePercent: 'Taux (%)',
        riskSectionTitle: 'Configuration des risques',
        riskExcellentMin: 'Seuil Excellent (min)',
        riskGoodMin: 'Seuil Bon (min)',
        riskModerateMin: 'Seuil Modéré (min)',
        riskHighMin: 'Seuil Risque élevé (min)',
        highRiskCutoff: 'Seuil membres à risque',
        topMembersMinScore: 'Seuil top members',
        topMembersCount: 'Nombre de top members',
        highRiskCount: 'Nombre de membres à risque',
        saveButton: 'Sauvegarder les paramètres',
        saveError: 'Erreur lors de la sauvegarde',
      },
      toast: {
        paymentConfirmed: 'Paiement confirmé !',
        csvDownloaded: 'Export CSV téléchargé',
        exportError: 'Erreur lors de l\'export',
        pdfDownloaded: 'Rapport PDF téléchargé',
        exportPdfError: 'Erreur lors de l\'export PDF',
        rotationSuccess: 'Versement effectué à {recipient}',
        rotationError: 'Erreur lors de la rotation',
        remindersSent: 'Rappels envoyés à {count} membre(s)',
        smartRemindersSent: 'Rappels intelligents: {count} ciblé(s), risque élevé {highRisk}, push {push}, SMS {sms}, email {email}',
        sendError: 'Erreur lors de l\'envoi',
      },
    },
  },
  
  en: {
    // Navigation
    nav: {
      dashboard: 'Dashboard',
      tontines: 'My Tontines',
      contributions: 'Contributions',
      referrals: 'Referrals',
      chat: 'AI Coach',
      admin: 'Admin',
      profile: 'My Profile',
      settings: 'Settings',
      logout: 'Log out',
    },
    
    // Auth
    auth: {
      login: 'Login',
      register: 'Sign Up',
      email: 'Email',
      password: 'Password',
      fullName: 'Full Name',
      phone: 'Phone',
      country: 'Country',
      loginButton: 'Sign In',
      registerButton: 'Sign Up',
      forgotPassword: 'Forgot password?',
      noAccount: "Don't have an account?",
      hasAccount: 'Already have an account?',
      referralCode: 'Referral code (optional)',
    },
    
    // Dashboard
    dashboard: {
      welcome: 'Welcome',
      totalTontines: 'Total Tontines',
      totalContributed: 'Total Contributed',
      nextPayout: 'Next Payout',
      pendingContributions: 'Pending Contributions',
      recentActivity: 'Recent Activity',
      quickActions: 'Quick Actions',
      createTontine: 'Create a tontine',
      joinTontine: 'Join a tontine',
    },
    
    // Tontines
    tontine: {
      create: 'Create a tontine',
      join: 'Join',
      name: 'Tontine name',
      description: 'Description',
      type: 'Type',
      types: {
        rosca: 'ROSCA (Rotating)',
        asca: 'ASCA (Accumulating)',
        flex_asca: 'Flexible ASCA (free savings)',
        hybrid: 'Hybrid',
      },
      contribution: 'Contribution',
      frequency: 'Frequency',
      frequencies: {
        weekly: 'Weekly',
        biweekly: 'Bi-weekly',
        monthly: 'Monthly',
      },
      currency: 'Currency',
      maxMembers: 'Max Members',
      currentMembers: 'Current Members',
      startDate: 'Start Date',
      rules: 'Rules',
      status: 'Status',
      statuses: {
        active: 'Active',
        pending: 'Pending',
        completed: 'Completed',
        paused: 'Paused',
      },
      members: 'Members',
      position: 'Position',
      admin: 'Administrator',
      member: 'Member',
    },
    
    // Settings
    settings: {
      title: 'Settings',
      paymentMode: 'Payment Mode',
      paymentModes: {
        adminOnly: 'Admin Only',
        adminOnlyDesc: 'Admin records all contributions',
        direct: 'Direct Payment',
        directDesc: 'Members pay directly via the app',
      },
      visibilityMode: 'Visibility Mode',
      visibilityModes: {
        restricted: 'Restricted',
        restrictedDesc: 'Members see only their own information',
        transparent: 'Transparent',
        transparentDesc: 'Full transparency - everyone sees everything',
      },
      automation: 'Automation',
      reminders: 'Automatic Reminders',
      reminderDays: 'Days before due date',
      autoRotation: 'Automatic Rotation',
      penalties: 'Penalties',
      penaltyEnabled: 'Enable Penalties',
      penaltyRate: 'Penalty Rate',
      gracePeriod: 'Grace Period (days)',
      save: 'Save',
      saved: 'Settings saved',
    },
    
    // Contributions
    contributions: {
      title: 'Contributions',
      pay: 'Pay',
      record: 'Record Payment',
      amount: 'Amount',
      date: 'Date',
      method: 'Method',
      status: 'Status',
      statuses: {
        completed: 'Completed',
        pending: 'Pending',
        failed: 'Failed',
      },
      paymentMethods: {
        wave: 'Wave',
        orangeMoney: 'Orange Money',
        stripe: 'Credit Card',
        cash: 'Cash',
      },
      selectMember: 'Select a member',
      recordFor: 'Record for',
    },
    
    // Notifications
    notifications: {
      title: 'Notifications',
      subtitle: 'Track your alerts and recent actions',
      markAllRead: 'Mark all as read',
      markAllSuccess: 'Notifications marked as read',
      noNotifications: 'No notifications',
      showUnread: 'Show unread',
      showAll: 'Show all',
      viewAll: 'View all',
      loadError: 'Failed to load notifications',
      actionError: 'Failed to update notification',
      now: 'Just now',
      minutesAgo: '{count} min ago',
      hoursAgo: '{count} h ago',
      daysAgo: '{count} d ago',
      types: {
        contributionRecorded: 'Contribution recorded',
        contributionReminder: 'Contribution reminder',
        payoutReceived: 'Payout received',
        memberJoined: 'New member',
        rotationExecuted: 'Rotation executed',
        tontineInvite: 'Tontine invitation',
        referralBonus: 'Referral bonus',
      },
    },
    
    // Invitations
    invite: {
      title: 'Invite Members',
      link: 'Invitation Link',
      qrCode: 'QR Code',
      code: 'Invitation Code',
      email: 'By Email',
      addManual: 'Add Manually',
      copyLink: 'Copy Link',
      copied: 'Link copied!',
      sendInvite: 'Send Invitation',
      expires: 'Expires in',
      usesLabel: 'Uses',
      auditTitle: 'Invitation history',
      reasonLabel: 'Reason',
      auditEvents: {
        invite_created: 'Invitation created',
        invite_redeemed: 'Invitation redeemed',
        invite_expired: 'Invitation expired',
        invite_revoked: 'Invitation revoked',
      },
      days: 'days',
    },
    
    // Common
    common: {
      loading: 'Loading...',
      error: 'Error',
      success: 'Success',
      cancel: 'Cancel',
      confirm: 'Confirm',
      save: 'Save',
      delete: 'Delete',
      edit: 'Edit',
      view: 'View',
      back: 'Back',
      page: 'Page',
      pageSize: 'Size',
      next: 'Next',
      previous: 'Previous',
      search: 'Search',
      filter: 'Filter',
      export: 'Export',
      import: 'Import',
      download: 'Download',
      upload: 'Upload',
      yes: 'Yes',
      no: 'No',
      all: 'All',
      none: 'None',
    },

    validation: {
      required: 'This field is required.',
      email: 'Please enter a valid email address.',
      invalid: 'The entered value is invalid.',
      minLength: 'Please enter at least {min} characters.',
      minValue: 'The value must be greater than or equal to {min}.',
      maxValue: 'The value must be less than or equal to {max}.',
      invalidFormat: 'The entered format is invalid.',
    },
    
    // Countries
    countries: {
      SN: 'Senegal',
      CA: 'Canada',
      FR: 'France',
      CI: 'Ivory Coast',
      ML: 'Mali',
      BF: 'Burkina Faso',
      CM: 'Cameroon',
      US: 'United States',
    },
    
    // PWA
    pwa: {
      install: 'Install',
      installNow: 'Install now',
      bannerTitle: `Install ${APP_NAME}`,
      bannerDescription: 'Quick access to your tontines from your home screen.',
      iosInstructions: 'Tap Share then "Add to Home Screen"',
    },

    authPage: {
      backHome: 'Back to home',
      loginDescription: 'Sign in to your account',
      registerDescription: 'Create your account',
      loginError: 'Login error',
      registerError: 'Registration error',
      emailPlaceholder: 'your@email.com',
      namePlaceholder: 'Amadou Diallo',
      phoneOptional: 'Phone (optional)',
      phonePlaceholder: '+221 77 123 45 67',
      createAccountButton: 'Create my account',
    },

    referralsPage: {
      title: 'Referrals',
      subtitle: 'Invite friends and earn rewards',
      yourCode: 'Your referral code',
      shareAction: 'Share',
      codeCopied: 'Code copied!',
      linkCopied: 'Referral link copied!',
      shareText: 'Join {appName} and manage your tontines safely! Use my referral code: {referralCode}',
      shareTitle: '{appName} - Referrals',
      stats: {
        referrals: 'Referrals',
        active: 'Active',
        bonusEarned: 'Bonus earned',
        points: 'Points',
      },
      benefitsTitle: 'Your benefits',
      myReferrals: 'My referrals ({count})',
      noReferrals: 'No referrals yet',
      noReferralsHelp: 'Share your referral code to invite friends and earn bonuses!',
      status: {
        active: 'Active',
        pending: 'Pending',
      },
    },

    landing: {
      navLogin: 'Login',
      navStart: 'Get started',
      heroTagline: 'Community savings reinvented',
      heroTitlePrefix: 'Manage your tontines with',
      heroTitleHighlight: 'confidence',
      heroDescription: 'The professional platform to create, manage, and secure your tontines. From Senegal to Canada, modernize your collective savings.',
      heroPrimaryCta: 'Create my tontine',
      heroSecondaryCta: 'Learn more',
      freeToStart: 'Free to get started',
      secureData: 'Secure data',
      imageAlt: 'Tontine application',
      savedFcfa: 'FCFA saved',
      typesEyebrow: 'Tontine types',
      typesTitle: 'Choose your model',
      featuresEyebrow: 'Features',
      featuresTitle: 'Everything you need',
      ctaTitle: 'Ready to modernize your tontine?',
      ctaDescription: 'Join thousands of users who trust {appName} to manage their collective savings.',
      ctaButton: 'Start for free',
      footerCopyright: '© {year} {appName}. All rights reserved. TRA-TECH. Email: contact@tra-tech.com/ sadiboutra@gmail.com. Headquarters: Ouest Foire, Dakar, Senegal.',
      footerPrivacy: 'Privacy',
      footerTerms: 'Terms',
      features: {
        group: {
          title: 'Simplified group management',
          description: 'Invite members, define rules, and track contributions in real time.',
        },
        security: {
          title: 'Maximum security',
          description: 'End-to-end encryption, full audit trail, and automatic fraud detection.',
        },
        payments: {
          title: 'Flexible payments',
          description: 'Wave, Orange Money, Stripe - all your preferred payment methods.',
        },
        coach: {
          title: 'Integrated AI coach',
          description: 'An intelligent assistant to guide you in creating and managing your tontines.',
        },
        currencies: {
          title: 'Multi-currency',
          description: 'XOF for Senegal, CAD for Canada. Manage your tontines wherever you are.',
        },
        dashboard: {
          title: 'Dashboards',
          description: 'Visualize savings, track rotations, and anticipate payouts.',
        },
      },
      types: {
        rosca: {
          title: 'Traditional rotation',
          description: 'Each member receives the pot in turn. Simple and fair.',
        },
        asca: {
          title: 'Collective savings',
          description: 'Build a common fund with optional member loans.',
        },
        hybrid: {
          title: 'Custom',
          description: 'Combine rotation and savings according to your group needs.',
        },
      },
    },

    dashboardPage: {
      greetings: {
        morning: 'Good morning',
        afternoon: 'Good afternoon',
        evening: 'Good evening',
      },
      overviewSubtitle: 'Here is an overview of your tontines',
      coachButton: 'AI Coach',
      newTontine: 'New tontine',
      stats: {
        myTontines: 'My tontines',
        activeCount: '{count} active',
        totalContributed: 'Total contributed',
        totalReceived: 'Total received',
        pending: 'Pending',
        contributionsSuffix: 'contributions',
      },
      myTontinesTitle: 'My tontines',
      viewAll: 'View all',
      empty: {
        title: 'No tontine',
        description: 'Create your first tontine or join an existing group to get started.',
        createButton: 'Create a tontine',
      },
      membersCount: '{current}/{max} members',
      status: {
        active: 'Active',
      },
      contributionMonthly: '{amount} / month',
      roundLabel: 'Round {round}',
      quickActionsTitle: 'Quick actions',
      quick: {
        createTitle: 'Create a tontine',
        createDesc: 'Start a new group',
        contributeTitle: 'Contribute',
        contributeDesc: 'Make a payment',
        chatTitle: 'AI Coach',
        chatDesc: 'Ask a question',
      },
      nextContributionTitle: 'Next contribution',
      nextContributionDue: 'Due this month',
      catchup: {
        title: 'My catch-up plans',
        installments: '{count} installment(s)',
        acceptButton: 'Accept plan',
        acceptedToast: 'Catch-up plan accepted',
        acceptError: 'Unable to accept plan',
        status: {
          proposed: 'Proposed',
          accepted: 'Accepted',
          in_progress: 'In progress',
          failed: 'Failed',
        },
      },
    },

    tontinesPage: {
      title: 'My Tontines',
      subtitle: 'Manage and track your savings groups',
      newTontine: 'New tontine',
      searchPlaceholder: 'Search a tontine...',
      roundLabel: 'Round {round}',
      viewDetails: 'View details',
      empty: {
        noResults: 'No results',
        noTontine: 'No tontine',
        tryOtherSearch: 'Try another search term',
        createFirst: 'Create your first tontine to start saving as a group',
      },
      form: {
        namePlaceholder: 'Ex: Diallo Family Tontine',
        descriptionPlaceholder: 'Group objective and rules...',
        contributionAmount: 'Contribution amount',
        createButton: 'Create tontine',
      },
    },

    joinPage: {
      invalidOrExpired: 'Invalid or expired invitation',
      welcomeToast: 'Welcome to {tontineName}!',
      joinError: 'Error while joining',
      invalidTitle: 'Invalid invitation',
      backHome: 'Back to home',
      title: 'Join tontine',
      fullTontine: 'This tontine is full',
      joinButton: 'Join tontine',
      loginToJoin: 'Log in to join',
      needAccount: 'You need an account to join',
    },

    chatPage: {
      title: 'Tontine Coach',
      poweredByAi: 'Powered by AI',
      thinking: 'Thinking...',
      suggestionsTitle: 'Suggestions',
      inputPlaceholder: 'Ask your question...',
      errorMessage: 'Sorry, an error occurred. Please try again.',
      welcomeMessage: 'Hello {firstName}! I am Coach Tontine, your intelligent assistant. 🎯\n\nI can help you:\n• Understand different tontine types\n• Create and configure your group\n• Answer your collective savings questions\n\nHow can I help you today?',
      suggestions: {
        rosca: 'What is a ROSCA tontine?',
        amount: 'How to choose the right contribution amount?',
        rules: 'What are the rules of a good group?',
      },
    },

    profilePage: {
      title: 'My profile',
      subtitle: 'Manage your personal information',
      accountInfo: 'Account information',
      accountInfoDesc: 'Update your profile data',
      photoTitle: 'Profile photo',
      photoHint: 'Upload a clear square image up to 2 MB.',
      photoAlt: 'Profile photo',
      uploadPhoto: 'Change photo',
      removePhoto: 'Remove',
      invalidPhotoType: 'Please select a valid image file.',
      photoTooLarge: 'The photo must be smaller than 2 MB.',
      photoReadError: 'Unable to read this image.',
      saved: 'Profile updated',
      saveError: 'Error updating profile',
    },

    settingsPage: {
      subtitle: 'Customize your experience',
      profileTitle: 'Profile',
      profileDesc: 'Review your public information and profile photo.',
      editProfile: 'Edit profile',
      languageTitle: 'Language',
      languageDesc: 'Choose the application language',
      languageLabel: 'Display language',
      notificationsTitle: 'Notifications',
      notificationsDesc: 'Manage push notifications and alerts',
      preferencesTitle: 'Preferences',
      preferencesDesc: 'These preferences are automatically synced with your account.',
      darkModeTitle: 'Dark mode',
      darkModeDesc: 'Instantly apply the dark theme across your workspace.',
      emailAlertsTitle: 'Email alerts',
      emailAlertsDesc: 'Keep receiving reminders and key updates by email.',
      newsletterTitle: 'Product news',
      newsletterDesc: 'Receive product updates and practical tips.',
      privacyTitle: 'Privacy',
      privacyDesc: 'Choose how visible your profile should be in the app.',
      visibilityLabel: 'Profile visibility',
      saveError: 'Error saving preferences',
      visibilityOptions: {
        restricted: 'Restricted',
        restrictedDesc: 'Only essential profile details are visible.',
        transparent: 'Transparent',
        transparentDesc: 'Your full profile is more visible to other members.',
      },
    },

    pushManager: {
      title: 'Push notifications',
      description: 'Receive alerts even when the app is closed',
      notSupportedMessage: 'Push notifications are not supported by this browser. Use Chrome or Firefox to enable this feature.',
      enableTitle: 'Enable notifications',
      enableDescription: 'Contribution reminders, payment confirmations, alerts',
      enabledMessage: 'Notifications enabled',
      notificationTypesTitle: 'Notification types:',
      sendTest: 'Send a test notification',
      permissionDeniedTitle: 'Permission denied',
      permissionDeniedDescription: 'You blocked notifications. Update your browser settings to re-enable them.',
      compact: {
        notSupported: 'Not supported by this browser',
        enabled: 'Enabled',
        disabled: 'Disabled',
      },
      notificationTypes: {
        reminders: '📅 Contribution reminders (D-3, D-1, Due day)',
        paymentConfirmation: '✅ Payment received confirmation',
        contributionRecorded: '🧾 Contribution recorded by an admin',
        newMember: '👋 New member joined your tontine',
        rotation: '🔄 Rotation executed',
        referralBonus: '🎁 Referral bonus and referral progress',
        tontineInvite: '📩 Tontine invitations and statuses',
        catchupPlan: '📌 Catch-up plans to review',
        importantAlerts: '⚠️ Important alerts',
      },
      toast: {
        permissionDenied: 'Notification permission denied',
        enabled: 'Notifications enabled!',
        enableError: 'Error enabling notifications',
        disabled: 'Notifications disabled',
        disableError: 'Error disabling notifications',
        testSent: 'Test notification sent!',
        testError: 'Error sending test notification',
      },
    },

    risk: {
      levels: {
        excellent: 'Excellent',
        good: 'Good',
        moderate: 'Moderate',
        high: 'High Risk',
        critical: 'Critical',
      },
      badgeTitle: 'Risk score: {score}/100',
      loadError: 'Error while loading',
      memberDialogTitle: 'Risk Score - {memberName}',
      memberDialogDescription: 'AI analysis of reliability profile',
      factorsTitle: 'Evaluation factors',
      factors: {
        payment_regularity: 'Payment regularity',
        timeliness: 'Timeliness',
        attendance: 'Attendance',
        engagement: 'Engagement',
        history: 'History',
        contribution_consistency: 'Contribution consistency',
      },
      aiAnalysisTitle: 'AI Analysis',
      recommendationsTitle: 'Recommendations',
      summaryTitle: 'Risk Analysis',
      averageScore: 'Average score',
      distribution: 'Distribution',
      distributionItemTitle: '{level}: {count} member(s)',
      highRiskMembers: '{count} high-risk member(s)',
      topMembers: 'Top members',
      topMembersThresholdHint: 'Top members threshold = {minScore}',
      topMembersEmpty: 'No eligible members (score ≥ {minScore})',
    },

    adminDashboard: {
      title: 'Administrator Dashboard',
      subtitle: 'Consolidated view of all your tontines',
      actions: {
        refresh: 'Refresh',
        exportSuccess: 'CSV export generated successfully',
        exportError: 'Error while exporting CSV',
        loadError: 'Unable to load admin dashboard',
      },
      stats: {
        managedTontines: 'Managed Tontines',
        managedTontinesSubtitle: 'Active and ongoing',
        totalCollected: 'Total Collected',
        thisMonth: 'This month',
        pendingContributions: 'Pending contributions',
        pendingMembers: '{count} members',
        riskAlerts: 'Risk Alerts',
        membersToWatch: 'Members to monitor',
      },
      charts: {
        contributionTrend: 'Contribution Trend',
        last30Days: 'Last 30 days',
        amount: 'Amount',
        participationByTontine: 'Participation Rate by Tontine',
        participation: 'Participation',
      },
      tontineFallbackName: 'Tontine',
      memberDistribution: {
        title: 'Member Distribution',
        active: 'Active',
        pending: 'Pending',
        inactive: 'Inactive',
      },
      risk: {
        title: 'Risk Alerts',
        subtitle: 'Members requiring attention',
        scoreLabel: 'Score',
        mock: {
          consecutiveLate: '3 consecutive delays',
          partialPayment: 'Partial payment',
          irregularity: 'Irregularity',
        },
      },
      quickView: {
        title: 'My Tontines',
        subtitle: 'Quick view of all your tontines',
        collected: 'Collected',
      },
      health: {
        title: 'Tontine Health',
        subtitle: 'Global score, trends, and priority actions',
        globalScore: 'Global score',
        atRiskCount: '{count} at-risk member(s)',
        trend30Days: '30-day trend',
        scoreAxis: 'Score',
        recommendedActions: 'Recommended actions',
        targetTontine: 'Target tontine',
        selectTontine: 'Select a tontine',
        ctaRemind: 'Send reminder',
        ctaCatchup: 'Catch-up plan',
        ctaGroupMessage: 'Group message',
        catchupStatusTitle: 'Catch-up plan tracking',
        catchupProposed: 'Proposed',
        catchupAccepted: 'Accepted',
        catchupInProgress: 'In progress',
        catchupFailed: 'Failed',
        topAtRisk: 'At-risk members',
        noRiskMembers: 'No at-risk members right now',
        noTontine: 'No tontine found for this action',
        actionError: 'Error while running admin action',
        groupMessageTemplate: 'Please regularize your contribution this week.',
      },
      access: {
        title: 'Admin access management',
        subtitle: 'Assign delegated roles with limited permissions',
        targetTontine: 'Target tontine',
        selectTontine: 'Select a tontine',
        member: 'Member',
        selectMember: 'Select a member',
        ownerExcludedHint: 'The owner cannot be assigned a lower delegated role.',
        noEligibleMembers: 'No eligible member available for assignment',
        role: 'Role',
        expiresAt: 'Expiration (optional)',
        assign: 'Assign access',
        currentAccess: 'Active access',
        empty: 'No delegated access for this tontine',
        revoke: 'Revoke',
        expiresLabel: 'Expires at',
        loadError: 'Unable to load admin access assignments',
        formMissing: 'Please select a member and a role',
        createSuccess: 'Admin access assigned successfully',
        createError: 'Error while assigning admin access',
        updateSuccess: 'Admin role updated',
        updateError: 'Error while updating admin role',
        revokeSuccess: 'Admin access revoked',
        revokeError: 'Error while revoking admin access',
        legendTitle: 'Role legend',
        legendManager: 'Full management (members, invites, settings)',
        legendCollector: 'Contribution tracking and reminders',
        legendViewer: 'Read-only access',
        roles: {
          manager: 'Manager',
          collector: 'Collector',
          viewer: 'Viewer',
        },
      },
    },

    tontineDetail: {
      notFound: 'Tontine not found',
      backToTontines: 'Back to tontines',
      restrictedInfo: 'Restricted mode active — you only see limited information.',
      accessSummary: {
        title: 'Effective access',
        roleOwner: 'Role: Owner',
        roleManager: 'Role: Manager',
        roleCollector: 'Role: Collector',
        roleViewer: 'Role: Viewer',
        roleMember: 'Role: Member',
        capabilities: {
          manageMembers: 'Manage members',
          manageInvites: 'Manage invites',
          recordContributions: 'Record contributions',
          updateSettings: 'Settings',
          executeRotation: 'Execute rotation',
          viewSensitiveData: 'Sensitive data',
        },
      },
      followOnlyMessage: 'Tracking-only mode - contact the admin',
      rulesTitle: 'Internal rules',
      noRules: 'No rules defined',
      infoTitle: 'Information',
      createdOn: 'Created on',
      currencyXof: 'CFA Franc (XOF)',
      currencyCad: 'Canadian Dollar (CAD)',
      nextPayout: 'Next payout',
      membersTitle: 'Members ({count})',
      positionLabel: 'Position #{position}',
      masked: 'Hidden',
      paid: 'Paid',
      viewRiskScore: 'View risk score',
      contributionHistory: 'Contribution history',
      restrictedContributionsInfo: 'Restricted mode — only your contributions are visible.',
      noContributions: 'No contributions recorded',
      roundLabel: 'Round {round}',
      tabs: {
        contributions: 'Contributions',
      },
      stats: {
        contribution: 'Contribution',
        totalCollected: 'Total collected',
        currentRound: 'Current round',
      },
      actions: {
        invite: 'Invite',
        add: 'Add',
        reminders: 'Reminders',
        smartReminders: 'Smart reminders',
        rotation: 'Rotation',
      },
      distribution: {
        title: 'Distribution summary',
        totalPot: 'Distributed pot: {amount}',
        newRound: 'New round: {round}',
        closeAria: 'Close distribution summary',
        memberFallback: 'Member',
      },
      dialogs: {
        import: {
          title: 'Import members',
          description: 'Add multiple members with a CSV file',
        },
        invite: {
          title: 'Invite members',
          description: 'Share the link or QR code to invite members',
        },
        addMember: {
          title: 'Add a member',
          description: 'Manually add a member to the tontine',
        },
        settings: {
          title: 'Automation settings',
          description: 'Configure reminders and automatic rotations',
        },
      },
      paymentDialog: {
        recordContribution: 'Record a contribution',
        chooseMethod: 'Choose payment method',
        recordMemberContribution: 'Record a member contribution',
        selectPreferredMethod: 'Select your preferred payment method',
      },
      payment: {
        stripeCadOnly: 'Stripe available only for CAD',
        waveXofOnly: 'Wave available only for XOF',
        error: 'Payment error',
        you: 'you',
        recordedFor: 'Contribution recorded for {memberName}',
        recordError: 'Error while recording',
        waveInstructions: 'Wave instructions',
        reference: 'Reference',
        amountToRecord: 'Amount to record',
        mobileMoney: 'Mobile Money',
        cardBrands: 'Visa, Mastercard',
        recordCash: 'Record (cash)',
        manualContribution: 'Manual contribution',
        manualPayment: 'Manual payment',
      },
      import: {
        mode: 'Import mode',
        modeBasic: 'Basic (name, email, phone)',
        modeFull: 'Full (+ position, initial amount)',
        downloadTemplate: 'Download template',
        csvFile: 'CSV file',
        resultSummary: '{imported} imported, {skipped} skipped',
        submit: 'Import members',
        downloadError: 'Error while downloading',
        selectCsvError: 'Please select a CSV file',
        importError: 'Import error',
      },
      invite: {
        enterOneEmail: 'Enter at least one email',
        sentCount: 'Invitations sent to {count} people',
        emailPlaceholder: 'email1@example.com, email2@example.com',
        sendInvites: 'Send invitations',
      },
      addMember: {
        addedSuccess: 'Member added successfully',
        addError: 'Error while adding member',
        rotationPosition: 'Rotation position',
        positionHelp: 'Leave empty for the next available position',
        sendInvite: 'Send invitation',
        sendInviteHelp: 'An email will be sent to the new member',
      },
      settings: {
        remindersHelp: 'Sent automatically before the due date',
        reminderDay: 'D-{day}',
        smartReminders: 'Smart reminders',
        smartRemindersHelp: 'Prioritize at-risk members with push/SMS channel then email fallback',
        smartUrgentDays: 'Urgent days (at-risk members)',
        autoRotationHelp: 'Run draw on scheduled date',
        latePenalties: 'Late penalties',
        latePenaltiesHelp: 'Apply fees in case of late payment',
        penaltyRatePercent: 'Rate (%)',
        riskSectionTitle: 'Risk configuration',
        riskExcellentMin: 'Excellent threshold (min)',
        riskGoodMin: 'Good threshold (min)',
        riskModerateMin: 'Moderate threshold (min)',
        riskHighMin: 'High risk threshold (min)',
        highRiskCutoff: 'High-risk members cutoff',
        topMembersMinScore: 'Top members threshold',
        topMembersCount: 'Top members count',
        highRiskCount: 'High-risk members count',
        saveButton: 'Save settings',
        saveError: 'Error while saving',
      },
      toast: {
        paymentConfirmed: 'Payment confirmed!',
        csvDownloaded: 'CSV export downloaded',
        exportError: 'Error during export',
        pdfDownloaded: 'PDF report downloaded',
        exportPdfError: 'Error during PDF export',
        rotationSuccess: 'Payout executed to {recipient}',
        rotationError: 'Error during rotation',
        remindersSent: 'Reminders sent to {count} member(s)',
        smartRemindersSent: 'Smart reminders: {count} targeted, high risk {highRisk}, push {push}, SMS {sms}, email {email}',
        sendError: 'Error while sending',
      },
    },
  },
  
  // Wolof (Sénégal)
  wo: {
    nav: {
      dashboard: 'Taablo',
      tontines: 'Samay Tontines',
      contributions: 'Cotisations',
      referrals: 'Parrainage',
      chat: 'Coach IA',
      admin: 'Admin',
      profile: 'Samay profil',
      settings: 'Paramètres',
      logout: 'Génne',
    },
    auth: {
      login: 'Dugg',
      register: 'Bindu',
      email: 'Email',
      password: 'Baatu jàll',
      fullName: 'Tur bu mat',
      phone: 'Telefon',
      country: 'Réew',
      loginButton: 'Dugg',
      registerButton: 'Bindu',
      forgotPassword: 'Fattelu nga sa baatu jàll?',
      noAccount: 'Amul sa kont?',
      hasAccount: 'Am nga sa kont?',
      referralCode: 'Kodu parrainage',
    },
    dashboard: {
      welcome: 'Dalal jamm',
      totalTontines: 'Tontines yépp',
      totalContributed: 'Cotisations yépp',
      nextPayout: 'Versement bi ci topp',
      pendingContributions: 'Cotisations yu xaar',
    },
    common: {
      loading: 'Yegsi...',
      error: 'Njuumte',
      success: 'Baax na',
      cancel: 'Neenal',
      confirm: 'Dëggal',
      save: 'Denc',
      back: 'Déllusiwaat',
      page: 'Xët',
      pageSize: 'Rëyaay',
      next: 'Ci topp',
      previous: 'Ci gannaaw',
      yes: 'Waaw',
      no: 'Déet',
      all: 'Lépp',
      none: 'Dara',
    },

    validation: {
      required: 'War nga feesal bii champ.',
      email: 'Dugalal email bu baax.',
      invalid: 'Valeur bi baaxul.',
      minLength: 'War nga bind lu tollu ci {min} caracteres walla yokk ci kaw.',
      minValue: 'Valeur bi war na gannaaw walla yem ak {min}.',
      maxValue: 'Valeur bi war na suufe walla yem ak {max}.',
      invalidFormat: 'Format bi baaxul.',
    },

    notifications: {
      title: 'Notifications',
      subtitle: 'Toppal sa ay alertes ak actions yu mujj',
      markAllRead: 'Jàngal lépp',
      markAllSuccess: 'Notifications yi jàng nañu leen',
      noNotifications: 'Amul notifications',
      showUnread: 'Wone yi ñu jàngagul',
      showAll: 'Wone lépp',
      viewAll: 'Xool lépp',
      loadError: 'Njuumte ci yebbi notifications yi',
      actionError: 'Njuumte ci yeesal bi',
      now: 'Léegi',
      minutesAgo: '{count} min la',
      hoursAgo: '{count} waxtu la',
      daysAgo: '{count} bés la',
      types: {
        contributionRecorded: 'Cotisation enregistrée',
        contributionReminder: 'Rappel cotisation',
        payoutReceived: 'Versement jot na',
        memberJoined: 'Membre bu bees',
        rotationExecuted: 'Rotation def na',
        tontineInvite: 'Invitation tontine',
        referralBonus: 'Bonus parrainage',
      },
    },
    pwa: {
      install: 'Installe',
      installNow: 'Installe léegi',
      bannerTitle: `Installe ${APP_NAME}`,
      bannerDescription: 'Jël app bi ci sa écran bu njëkk.',
      iosInstructions: 'Tàppal Partager te "Sur l\'écran d\'accueil"',
    },

    authPage: {
      backHome: "Dellu ci kër gi",
      loginDescription: 'Dugg ci sa kont',
      registerDescription: 'Sos sa kont',
      loginError: 'Njuumte bu dugg',
      registerError: 'Njuumte bu bindu',
      emailPlaceholder: 'sa@email.com',
      namePlaceholder: 'Amadou Diallo',
      phoneOptional: 'Telefon (tann)',
      phonePlaceholder: '+221 77 123 45 67',
      createAccountButton: 'Sos samay kont',
    },

    referralsPage: {
      title: 'Parrainage',
      subtitle: 'Woo say xarit te am ay récompense',
      yourCode: 'Sa kodu parrainage',
      shareAction: 'Seddoo',
      codeCopied: 'Kodu bi kopie na!',
      linkCopied: 'Liyen parrainage bi kopie na!',
      shareText: 'Ñëwal ci {appName} te say tontine yi nga doxal ko ak kersa! Jëfandikool sama kodu parrainage: {referralCode}',
      shareTitle: '{appName} - Parrainage',
      stats: {
        referrals: 'Filleuls',
        active: 'Aktif',
        bonusEarned: 'Bonus bu am',
        points: 'Points',
      },
      benefitsTitle: 'Sa njariñ',
      myReferrals: 'Samay filleuls ({count})',
      noReferrals: 'Amul filleul fii léegi',
      noReferralsHelp: 'Seddoole sa kodu parrainage ngir woo say xarit te am ay bonus!',
      status: {
        active: 'Aktif',
        pending: 'Ci xaar',
      },
    },

    landing: {
      navLogin: 'Dugg',
      navStart: 'Tambali',
      heroTagline: 'Epargne communautaire bu bees',
      heroTitlePrefix: 'Say tontine yi nga doxal ak',
      heroTitleHighlight: 'kóolute',
      heroDescription: 'Plateforme bu profesioneel ngir sos, doxal te aar say tontine yi. Dale ko Senegaal ba Kanada, yeesala sa épargne collective.',
      heroPrimaryCta: 'Sos sama tontine',
      heroSecondaryCta: 'Gën a xam',
      freeToStart: 'Dofal ngir tambali',
      secureData: 'Données yi ñu aar',
      imageAlt: 'Application bu tontine',
      savedFcfa: 'FCFA yi ñu denc',
      typesEyebrow: 'Xeetu tontine yi',
      typesTitle: 'Tannal sa formule',
      featuresEyebrow: 'Fonctionnalités',
      featuresTitle: 'Lépp li ngay soxla',
      ctaTitle: 'Ndax dafa jot ngir yeesal sa tontine?',
      ctaDescription: 'Bokk ak ay junni nit ñi wóor {appName} ngir doxal seen épargne collective.',
      ctaButton: 'Tambali ci lu amul fayda',
      footerCopyright: '© {year} {appName}. Lépp moom nañu ko. TRA-TECH. Email: contact@tra-tech.com/ sadiboutra@gmail.com. Siège social: Ouest Foire, Dakar, Sénégal.',
      footerPrivacy: 'Confidentialité',
      footerTerms: 'Conditions',
      features: {
        group: {
          title: 'Doxalin goupe bu yomb',
          description: 'Woo say membres, tegal yoon yi te topp cotisations yi ci jamono ji.',
        },
        security: {
          title: 'Aar gu kawe',
          description: 'Chiffrement bu mat, audit trail bu mat, ak fraude detection automatique.',
        },
        payments: {
          title: 'Paiement yu am solo',
          description: 'Wave, Orange Money, Stripe - yépp sa yoonu paiement yi.',
        },
        coach: {
          title: 'Coach IA bi ci biir',
          description: 'Jàppale bu xel ngir gindee la ci sos ak doxal say tontine yi.',
        },
        currencies: {
          title: 'Multi-devises',
          description: 'XOF ci Senegaal, CAD ci Kanada. Doxal sa tontine fu nekk.',
        },
        dashboard: {
          title: 'Tableaux de bord',
          description: 'Xoolal sa économies, topp rotations yi, te xam sa versements yi ci kanam.',
        },
      },
      types: {
        rosca: {
          title: 'Rotation bu cosaan',
          description: 'Membre bu nekk dafa jot pot bi ci ay waxtu yu toftaliku. Yomb te jub.',
        },
        asca: {
          title: 'Epargne collective',
          description: 'Dencal ay xaalis ci benn fond ak mboleem prêt ci seen biir.',
        },
        hybrid: {
          title: 'Personnalisé',
          description: 'Booleel rotation ak épargne selon soxla yi goupe bi.',
        },
      },
    },

    dashboardPage: {
      greetings: {
        morning: 'Asalaamaalekum',
        afternoon: 'Naka ngeen',
        evening: 'Jamm ak jàmm',
      },
      overviewSubtitle: 'Li nga am ci sa tontine yi fii la',
      coachButton: 'Coach IA',
      newTontine: 'Tontine bu bees',
      stats: {
        myTontines: 'Samay tontine',
        activeCount: '{count} aktif',
        totalContributed: 'Mboolem cotisation',
        totalReceived: 'Mboolem li nga jot',
        pending: 'Ci xaar',
        contributionsSuffix: 'cotisations',
      },
      myTontinesTitle: 'Samay tontine',
      viewAll: 'Xool lépp',
      empty: {
        title: 'Amul tontine',
        description: 'Sos sa njëkk tontine walla nga bokk ci benn goupe ngir tambali.',
        createButton: 'Sos tontine',
      },
      membersCount: '{current}/{max} membres',
      status: {
        active: 'Aktif',
      },
      contributionMonthly: '{amount} / weer',
      roundLabel: 'Tour {round}',
      quickActionsTitle: 'Actions yu gaaw',
      quick: {
        createTitle: 'Sos tontine',
        createDesc: 'Tambali goupe bu bees',
        contributeTitle: 'Cotiser',
        contributeDesc: 'Def versement',
        chatTitle: 'Coach IA',
        chatDesc: 'Laajal laaj',
      },
      nextContributionTitle: 'Cotisation bi ci topp',
      nextContributionDue: 'War nga fay ko ci weer wi',
      catchup: {
        title: 'Samay plans rattrapage',
        installments: '{count} versement(s)',
        acceptButton: 'Nangu plan bi',
        acceptedToast: 'Plan rattrapage nangu nañu ko',
        acceptError: 'Manul nangu plan bi',
        status: {
          proposed: 'Proposé',
          accepted: 'Accepté',
          in_progress: 'Ci dox',
          failed: 'Échoué',
        },
      },
    },

    tontinesPage: {
      title: 'Samay Tontines',
      subtitle: 'Doxal te topp sa groupes d\'épargne yi',
      newTontine: 'Tontine bu bees',
      searchPlaceholder: 'Seetal benn tontine...',
      roundLabel: 'Tour {round}',
      viewDetails: 'Xool détails',
      empty: {
        noResults: 'Amul résultats',
        noTontine: 'Amul tontine',
        tryOtherSearch: 'Jéemal beneen baat bu seet',
        createFirst: 'Sos sa njëkk tontine ngir tambali épargne ci goupe.',
      },
      form: {
        namePlaceholder: 'Ex: Tontine Famille Diallo',
        descriptionPlaceholder: 'Objectif ak yoonu goupe bi...',
        contributionAmount: 'Montant cotisation',
        createButton: 'Sos tontine bi',
      },
    },

    joinPage: {
      invalidOrExpired: 'Invitation bi baaxul walla dafa jeex',
      welcomeToast: 'Dalal ak jamm ci {tontineName}!',
      joinError: 'Njuumte bi ci bokk bi',
      invalidTitle: 'Invitation bi baaxul',
      backHome: 'Dellu ci kër gi',
      title: 'Bokk ci tontine bi',
      fullTontine: 'Tontine bii dafa fees',
      joinButton: 'Bokk ci tontine bi',
      loginToJoin: 'Dugg ngir bokk',
      needAccount: 'Nga wara am kont ngir bokk',
    },

    invite: {
      title: 'Woote ay membres',
      link: 'Liyen invitation',
      qrCode: 'QR Code',
      code: 'Kodu invitation',
      email: 'Ci email',
      addManual: 'Yokk ko ci loxo',
      copyLink: 'Kopie liyen bi',
      copied: 'Liyen bi kopie na!',
      sendInvite: 'Yónnee invitation bi',
      expires: 'Mujj ci',
      usesLabel: 'Utilisations',
      auditTitle: 'Taarixu invitations',
      reasonLabel: 'Sabab',
      auditEvents: {
        invite_created: 'Invitation sos nañu ko',
        invite_redeemed: 'Invitation jëfandikoo nañu ko',
        invite_expired: 'Invitation jeex na',
        invite_revoked: 'Invitation neenal nañu ko',
      },
      days: 'bés',
    },

    chatPage: {
      title: 'Coach Tontine',
      poweredByAi: 'IA mo koy doxal',
      thinking: 'Mu ngi xalaat...',
      suggestionsTitle: 'Ay jéego',
      inputPlaceholder: 'Laajal sa laaj...',
      errorMessage: 'Baal ma, njuumte am na. Jéemaatal.',
      welcomeMessage: 'Asalaamaalekum {firstName}! Maa ngi doon Coach Tontine, sa jàppale bu xel. 🎯\n\nMan naa la jàppale ci:\n• Xam xeetu tontine yi\n• Sos ak teg sa goupe\n• Tontu sa laaj yi ci épargne collective\n\nLan laa la man a jàppale tey?',
      suggestions: {
        rosca: 'Lan mooy benn tontine ROSCA?',
        amount: 'Naka laay tann montant cotisation bu baax?',
        rules: 'Lan mooy yoonu goupe bu baax?',
      },
    },

    profilePage: {
      title: 'Sama profil',
      subtitle: 'Say xibaar personnelles nga doxal',
      accountInfo: 'Xibaaru kont bi',
      accountInfoDesc: 'Yeesalal say données profil',
      photoTitle: 'Nataalu profil',
      photoHint: 'Yebal nataal bu leer te am carré baax, bu tollu 2 Mo rekk.',
      photoAlt: 'Nataalu profil',
      uploadPhoto: 'Soppi nataal bi',
      removePhoto: 'Far',
      invalidPhotoType: 'Tannal nataal bu baax.',
      photoTooLarge: 'Nataal bi warul weesu 2 Mo.',
      photoReadError: 'Maneesul jaŋg nataal bii.',
      saved: 'Profil bi yees na',
      saveError: 'Njuumte ci yeesal profil bi',
    },

    settingsPage: {
      subtitle: 'Defar sa expérience',
      profileTitle: 'Profil',
      profileDesc: 'Seetlul say xibaar ak nataalu profil bi.',
      editProfile: 'Soppi profil bi',
      languageTitle: 'Làkk',
      languageDesc: 'Tannal làkku application bi',
      languageLabel: 'Làkk bu affichage',
      notificationsTitle: 'Notifications',
      notificationsDesc: 'Doxal notifications push ak alertes',
      preferencesTitle: 'Préférences',
      preferencesDesc: 'Préférences yii dañuy dencu ak sa compte automatiquement.',
      darkModeTitle: 'Mode bu lëndëm',
      darkModeDesc: 'Defal thème bu lëndëm ci sa espace bépp fan.',
      emailAlertsTitle: 'Alertes email',
      emailAlertsDesc: 'Jotaat rappels ak mises à jour yu am solo ci email.',
      newsletterTitle: 'Xibaar yu bees',
      newsletterDesc: 'Jot xibaar yu bees ci produit bi ak ay conseils.',
      privacyTitle: 'Confidentialité',
      privacyDesc: 'Tannal ni sa profil di feeñ ci application bi.',
      visibilityLabel: 'Feeñug profil bi',
      saveError: 'Njuumte ci denc préférences yi',
      visibilityOptions: {
        restricted: 'Restreint',
        restrictedDesc: 'Ay xibaar yu gën a am solo rekk lañuy gis.',
        transparent: 'Transparent',
        transparentDesc: 'Sa profil bu mat moo gën a feeñ ci yeneen membres.',
      },
    },

    pushManager: {
      title: 'Notifications push',
      description: 'Jot ay alerte sax bu app bi tëj',
      notSupportedMessage: 'Navigateur bii du doxal notifications push. Jëfandikool Chrome walla Firefox ngir doxal ko.',
      enableTitle: 'Doxal notifications yi',
      enableDescription: 'Rappels cotisation, confirmations paiement ak alertes',
      enabledMessage: 'Notifications yi dox nañu',
      notificationTypesTitle: 'Xeetu notifications yi:',
      sendTest: 'Yónnee benn notification test',
      permissionDeniedTitle: 'Permission refusée',
      permissionDeniedDescription: 'Nga boloke notifications yi. Soppi sa paramètres navigateur ngir doxal leenat.',
      compact: {
        notSupported: 'Navigateur bii du ko doxal',
        enabled: 'Dox na',
        disabled: 'Doxul',
      },
      notificationTypes: {
        reminders: '📅 Rappels cotisation (J-3, J-1, Bés bi)',
        paymentConfirmation: '✅ Confirmation paiement bi jotna',
        contributionRecorded: '🧾 Cotisation admin bind na ko',
        newMember: '👋 Membre bu bees bokk na ci sa tontine',
        rotation: '🔄 Rotation bi amna',
        referralBonus: '🎁 Bonus parrainage ak yàmbat filleul',
        tontineInvite: '📩 Invitations tontine ak statuts',
        catchupPlan: '📌 Plans rattrapage yu nuy xool',
        importantAlerts: '⚠️ Alertes yu am solo',
      },
      toast: {
        permissionDenied: 'Permission notification refusée',
        enabled: 'Notifications yi dox nañu !',
        enableError: 'Njuumte ci doxal notifications yi',
        disabled: 'Notifications yi deactivated nañu',
        disableError: 'Njuumte ci feyal notifications yi',
        testSent: 'Notification test bi yónnee na !',
        testError: 'Njuumte ci test bi',
      },
    },

    risk: {
      levels: {
        excellent: 'Excellent',
        good: 'Baax',
        moderate: 'Digg-digg',
        high: 'Risque bu kawe',
        critical: 'Critique',
      },
      badgeTitle: 'Score risque: {score}/100',
      loadError: 'Njuumte ci yebbi bi',
      memberDialogTitle: 'Score Risque - {memberName}',
      memberDialogDescription: 'Analyse IA ci profil fiabilité bi',
      factorsTitle: 'Facteurs évaluation',
      factors: {
        payment_regularity: 'Regularité paiement',
        timeliness: 'Wàqtu',
        attendance: 'Présence',
        engagement: 'Engagement',
        history: 'Historique',
        contribution_consistency: 'Constance cotisation',
      },
      aiAnalysisTitle: 'Analyse IA',
      recommendationsTitle: 'Recommandations',
      summaryTitle: 'Analyse Risques',
      averageScore: 'Score moyen',
      distribution: 'Distribution',
      distributionItemTitle: '{level}: {count} membre(s)',
      highRiskMembers: '{count} membre(s) ci risque',
      topMembers: 'Membres yi gën',
      topMembersThresholdHint: 'Seuil top members = {minScore}',
      topMembersEmpty: 'Amul membre bu mën a nekk ci top (score ≥ {minScore})',
    },

    adminDashboard: {
      title: 'Tableau de bord Admin',
      subtitle: 'Xool bu mbooloo ci say tontine yépp',
      actions: {
        refresh: 'Yeesal',
        exportSuccess: 'Export CSV bi am na ak succès',
        exportError: 'Njuumte ci export CSV bi',
        loadError: 'Mënul yebbi tableau admin bi',
      },
      stats: {
        managedTontines: 'Tontines yu ngeen doxal',
        managedTontinesSubtitle: 'Aktif ak yi ci yoonu dox',
        totalCollected: 'Mboolem li ñu dajale',
        thisMonth: 'Weer wii',
        pendingContributions: 'Cotisations yu xaar',
        pendingMembers: '{count} membres',
        riskAlerts: 'Alertes Risque',
        membersToWatch: 'Membres yu wara topp',
      },
      charts: {
        contributionTrend: 'Doxalin Cotisations',
        last30Days: '30 bés yu mujj',
        amount: 'Montant',
        participationByTontine: 'Taux participation ci tontine bu nekk',
        participation: 'Participation',
      },
      tontineFallbackName: 'Tontine',
      memberDistribution: {
        title: 'Répartition Membres',
        active: 'Aktif',
        pending: 'Ci xaar',
        inactive: 'Inactif',
      },
      risk: {
        title: 'Alertes Risque',
        subtitle: 'Membres yu soxla attention',
        scoreLabel: 'Score',
        mock: {
          consecutiveLate: '3 retards yu toppante',
          partialPayment: 'Paiement bu matul',
          irregularity: 'Irrégularité',
        },
      },
      quickView: {
        title: 'Samay Tontines',
        subtitle: 'Xool bu gaaw ci say tontine yépp',
        collected: 'Collecté',
      },
      health: {
        title: 'Wér-gu-yaramu tontine bi',
        subtitle: 'Score global, tendance ak actions yu am solo',
        globalScore: 'Score global',
        atRiskCount: '{count} membre(s) ci risque',
        trend30Days: 'Tendance 30 fan',
        scoreAxis: 'Score',
        recommendedActions: 'Actions recommandées',
        targetTontine: 'Tontine bi ñuy jébbal',
        selectTontine: 'Tannal benn tontine',
        ctaRemind: 'Yónnee rappel',
        ctaCatchup: 'Plan rattrapage',
        ctaGroupMessage: 'Message groupé',
        catchupStatusTitle: 'Toppatoo plan rattrapage',
        catchupProposed: 'Proposé',
        catchupAccepted: 'Accepté',
        catchupInProgress: 'Ci dox',
        catchupFailed: 'Échoué',
        topAtRisk: 'Membres ci risque',
        noRiskMembers: 'Amul membre ci risque léegi',
        noTontine: 'Amul tontine bu ñu gën a jëfandikoo',
        actionError: 'Njuumte ci action admin bi',
        groupMessageTemplate: 'Jéggal, régularisez sa cotisation ci ayubis bii.',
      },
      access: {
        title: 'Saytu accès admin yi',
        subtitle: 'Doxal rôles yu délégué ak permissions yu limité',
        targetTontine: 'Tontine bi ñuy jébbal',
        selectTontine: 'Tannal benn tontine',
        member: 'Membre',
        selectMember: 'Tannal benn membre',
        ownerExcludedHint: 'Boroom bi mënul jot rôle délégué bu gën a suufe.',
        noEligibleMembers: 'Amul membre bu mën a jot accès bi',
        role: 'Rôle',
        expiresAt: 'Expiration (optionnel)',
        assign: 'Jox accès bi',
        currentAccess: 'Accès yi dox',
        empty: 'Amul accès délégué ci tontine bii',
        revoke: 'Dindi',
        expiresLabel: 'Mujje ci',
        loadError: 'Mënul yebbi accès admin yi',
        formMissing: 'Tannal membre ak rôle',
        createSuccess: 'Joxe nañu accès admin ak succès',
        createError: 'Njuumte ci joxe accès admin bi',
        updateSuccess: 'Rôle admin bi yees na',
        updateError: 'Njuumte ci yeesal rôle bi',
        revokeSuccess: 'Dindi nañu accès admin bi',
        revokeError: 'Njuumte ci dindi accès bi',
        legendTitle: 'Légende rôles yi',
        legendManager: 'Saytu lu mat (membres, invitations, paramètres)',
        legendCollector: 'Toppatoo cotisations ak rappels',
        legendViewer: 'Xool rekk',
        roles: {
          manager: 'Manager',
          collector: 'Collecteur',
          viewer: 'Observateur',
        },
      },
    },

    tontineDetail: {
      notFound: 'Tontine bi amul',
      backToTontines: 'Dellu ci tontine yi',
      restrictedInfo: 'Mode restriction dafa dox — xam-xam yu limité rekk ngay gis.',
      accessSummary: {
        title: 'Yoonu accès bi am',
        roleOwner: 'Rôle: Boroom',
        roleManager: 'Rôle: Manager',
        roleCollector: 'Rôle: Collecteur',
        roleViewer: 'Rôle: Observateur',
        roleMember: 'Rôle: Membre',
        capabilities: {
          manageMembers: 'Saytu membres',
          manageInvites: 'Saytu invitations',
          recordContributions: 'Enregistrer cotisations',
          updateSettings: 'Paramètres',
          executeRotation: 'Def rotation',
          viewSensitiveData: 'Données sensibles',
        },
      },
      followOnlyMessage: 'Mode suivi rekk - jokkoo ak admin bi',
      rulesTitle: 'Yoonu biir',
      noRules: 'Amul yoon yu ñu définie',
      infoTitle: 'Xibaar',
      createdOn: 'Sos nañu ko ci',
      currencyXof: 'Franc CFA (XOF)',
      currencyCad: 'Dollar canadien (CAD)',
      nextPayout: 'Versement bi ci topp',
      membersTitle: 'Membres ({count})',
      positionLabel: 'Position #{position}',
      masked: 'Nëbb',
      paid: 'Fay na',
      viewRiskScore: 'Xool score risque',
      contributionHistory: 'Historique cotisations',
      restrictedContributionsInfo: 'Mode restriction — sa cotisations rekk ngay gis.',
      noContributions: 'Amul cotisation enregistrée',
      roundLabel: 'Tour {round}',
      tabs: {
        contributions: 'Cotisations',
      },
      stats: {
        contribution: 'Cotisation',
        totalCollected: 'Total collecté',
        currentRound: 'Tour bi fi nekk',
      },
      actions: {
        invite: 'Inviter',
        add: 'Ajouter',
        reminders: 'Rappels',
        smartReminders: 'Rappels xel mu baax',
        rotation: 'Rotation',
      },
      distribution: {
        title: 'Résumé bi distribution',
        totalPot: 'Pot bi ñu distribué: {amount}',
        newRound: 'Tour bu bees: {round}',
        closeAria: 'Tëj résumé bi distribution',
        memberFallback: 'Membre',
      },
      dialogs: {
        import: {
          title: 'Importer ay membres',
          description: 'Yokk ay membres yu bari ak fichier CSV',
        },
        invite: {
          title: 'Inviter ay membres',
          description: 'Seddoole lien walla QR code ngir inviter ay membres',
        },
        addMember: {
          title: 'Yokk benn membre',
          description: 'Yokk benn membre ci sa loxo ci tontine bi',
        },
        settings: {
          title: 'Paramètres automatisation',
          description: 'Defar rappels ak rotations automatiques',
        },
      },
      paymentDialog: {
        recordContribution: 'Enregistrer benn cotisation',
        chooseMethod: 'Tannal mode paiement bi',
        recordMemberContribution: 'Enregistrer cotisation bu membre bi',
        selectPreferredMethod: 'Tannal sa yoonu paiement bu gën a baax',
      },
      payment: {
        stripeCadOnly: 'Stripe dafa jëfandikoo rekk ci CAD',
        waveXofOnly: 'Wave dafa jëfandikoo rekk ci XOF',
        error: 'Njuumte paiement',
        you: 'yow',
        recordedFor: 'Cotisation bi enregistrée na ngir {memberName}',
        recordError: 'Njuumte ci enregistrement bi',
        waveInstructions: 'Instructions Wave',
        reference: 'Référence',
        amountToRecord: 'Montant bi nga wara enregistrer',
        mobileMoney: 'Mobile Money',
        cardBrands: 'Visa, Mastercard',
        recordCash: 'Enregistrer (espèces)',
        manualContribution: 'Cotisation bu manuel',
        manualPayment: 'Paiement bu manuel',
      },
      import: {
        mode: 'Mode import',
        modeBasic: 'Basique (tur, email, telefon)',
        modeFull: 'Complet (+ position, montant bu njëkk)',
        downloadTemplate: 'Yebbi template bi',
        csvFile: 'Fichier CSV',
        resultSummary: '{imported} importés, {skipped} ignorés',
        submit: 'Importer ay membres',
        downloadError: 'Njuumte ci téléchargement bi',
        selectCsvError: 'Tannalal benn fichier CSV',
        importError: 'Njuumte import',
      },
      invite: {
        enterOneEmail: 'Dugal benn email bu néewnéew',
        sentCount: 'Invitations yi yónnee nañu ci {count} nit',
        emailPlaceholder: 'email1@example.com, email2@example.com',
        sendInvites: 'Yónnee invitations yi',
      },
      addMember: {
        addedSuccess: 'Membre bi yokk nañu ko ak succès',
        addError: 'Njuumte ci yokk bi',
        rotationPosition: 'Position ci rotation bi',
        positionHelp: 'Bàyyi ko suñuul, ngir position bu topp',
        sendInvite: 'Yónnee benn invitation',
        sendInviteHelp: 'Benn email dina dem ci membre bu bees bi',
      },
      settings: {
        remindersHelp: 'Ñuy yónnee leen automatiquement bala bés échéance bi',
        reminderDay: 'J-{day}',
        smartReminders: 'Rappels xel mu baax',
        smartRemindersHelp: 'Membres yi ci risque ñuy jëkk ci push/SMS, bu amul email lañuy yónnee',
        smartUrgentDays: 'Bés yu urgente (membres ci risque)',
        autoRotationHelp: 'Defal tirage bi ci bés bu ñu tëral',
        latePenalties: 'Pénalités retard',
        latePenaltiesHelp: 'Yokk frais bu amee retard',
        penaltyRatePercent: 'Taux (%)',
        riskSectionTitle: 'Paràmetres risk',
        riskExcellentMin: 'Seuil Excellent (min)',
        riskGoodMin: 'Seuil Bon (min)',
        riskModerateMin: 'Seuil Modéré (min)',
        riskHighMin: 'Seuil Risk élevé (min)',
        highRiskCutoff: 'Seuil membres à risque',
        topMembersMinScore: 'Seuil top members',
        topMembersCount: 'Nombre de top members',
        highRiskCount: 'Nombre de membres à risque',
        saveButton: 'Denc paramètres yi',
        saveError: 'Njuumte ci denc bi',
      },
      toast: {
        paymentConfirmed: 'Paiement bi confirmé na !',
        csvDownloaded: 'Export CSV bi yebbi na',
        exportError: 'Njuumte ci export bi',
        pdfDownloaded: 'Rapport PDF bi yebbi na',
        exportPdfError: 'Njuumte ci export PDF bi',
        rotationSuccess: 'Versement bi def nañu ko ci {recipient}',
        rotationError: 'Njuumte ci rotation bi',
        remindersSent: 'Rappels yi yónnee nañu leen ci {count} membre(s)',
        smartRemindersSent: 'Rappels xel mu baax: {count} ciblés, risque élevé {highRisk}, push {push}, SMS {sms}, email {email}',
        sendError: 'Njuumte ci yónnee bi',
      },
    },
  },
};

// Default language
export const defaultLanguage = 'fr';

// Supported languages with their names
export const supportedLanguages = [
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'wo', name: 'Wolof', flag: '🇸🇳' },
];
